export type SafetyRankingParameters = {
  driverEvents: DriverEvents;
  roadEvents: RoadEvents;
  acelerometerEvents: AcelerometerEvents;
  speedEvents: SpeedEvents;
};

export interface DriverEvents {
  distractedDriving: number;
  yawn: number;
  phoneUsage: number;
  eyesClosed: number;
  smoking: number;
}

export interface RoadEvents {
  tailgating: number;
}

export interface AcelerometerEvents {
  fastAcceleration: number;
  speedyTurn: number;
  hardBreak: number;
}

export interface SpeedEvents {
  roadSpeedLimit: number;
  vehicleSpeedLimit: number;
}

export enum ParametersCategory {
  driverEvents = 'DRIVER_EVENTS',
  roadEvents = 'ROAD_EVENTS',
  acelerometerEvents = 'ACELEROMETER_EVENTS',
  speedEvents = 'SPEED_EVENTS',
}

export const DEFAULT_SAFETY_RANKING_PARAMETERS: SafetyRankingParameters = {
  driverEvents: {
    distractedDriving: 0,
    yawn: 0,
    phoneUsage: 0,
    eyesClosed: 0,
    smoking: 0,
  },
  roadEvents: {
    tailgating: 0,
  },
  acelerometerEvents: {
    fastAcceleration: 0,
    speedyTurn: 0,
    hardBreak: 0,
  },
  speedEvents: {
    roadSpeedLimit: 0,
    vehicleSpeedLimit: 0,
  },
};
